import React,{Component} from "react";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import FuelReceiptEdit from "./FuelReceiptEdit";
import FuelRecieptAdd from "./FuelReceiptAdd";
import EnginOil from "./EnginOil";
class FuelReceipt extends Component{
        constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none"};
  
        }
/*        handleClick = () => {
            // force a re-render
            window.location.reload();
          }        */
    render(){
        return(

            <div className="container1">
{/*}                <p align="right">
        <button type="button" class="btn btn-default btn-sm" onClick={this.handleClick}>
          <span class="fa fa-refresh"></span> Refresh
        </button>
        </p>*/}

                <br></br><br></br>           
                <div width="100%" align="left" height="100%" scroll="hidden" >
                    <div  className="inner-profile" >
                    <span style={{textAlign:"right",height:"100%",paddingTop:20,width:"20%",float:"right",fontSize:20}}>Fuel Receipt</span>
                        <Tabs
                            value={this.state.value}
                            textColor ="inherit"
                            indicatorColor="secondary"
                            
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"block"}); 
                            }}
                        >
                            
                            <Tab label="Add / New" style={{paddingTop:"0px",fontSize:12}} />  
                            <Tab label="Remove" style={{paddingTop:"0px",fontSize:12}}/>
                        </Tabs>
                    </div>
                    <div  style={{display:this.state.tab1}}>
                            <FuelRecieptAdd/>
                        </div>
{/*Tab 2*/}

                        <div style={{display:this.state.tab2}}>
                            <FuelReceiptEdit/>
                        </div>


                </div>
                <br></br><br></br>
            </div>

    )}
}
export default FuelReceipt;